const state = {
    showTable: true,
    showChart: true,
    showSnapshot: false,
    dataColumnsSummaryListRepo:[
        {'label': 'Short Name', 'column':'campaign_short_name', 'graph': false, 'grid_active': true, 'graph_active': false},
        {'label': 'Name', 'column':'campaign_name', 'graph': false, 'grid_active': true, 'graph_active': false},
        {'label': '$Ad Cost', 'column':'ad_cost', 'graph': true, 'grid_active': true, 'graph_active': false},
        {'label': 'Leads', 'column':'count_new_prospects', 'graph': true, 'grid_active': true, 'graph_active': false},
        //{'label': 'Missed & Voicemails', 'column':'missed_voicemails', 'graph': true, 'grid_active': false, 'graph_active': false},
        //{'label': 'New Prospects', 'column':'count_new_prospects', 'graph': true, 'grid_active': true, 'graph_active': true},
        //{'label': '$Cost/prospect', 'column':'cost', 'graph': false, 'grid_active': false, 'graph_active': false},
        {'label': 'Converted', 'column':'count_prospects_become_customer', 'graph': true, 'grid_active': true, 'graph_active': false},
        //{'label': 'Converted * Prospect Count', 'column':'converted', 'graph': false, 'grid_active': false, 'graph_active': false},
        {'label': 'Units Rented', 'column':'count_units_rented', 'graph': true, 'grid_active': true, 'graph_active': false},
        {'label': 'Unit Rental SF', 'column':'count_units_rented_sf', 'graph': true, 'grid_active': true, 'graph_active': false},
        {'label': 'Unit Rental $', 'column':'cost_units_rented', 'graph': true, 'grid_active': true, 'graph_active': false},
        //{'label': 'Units Vacated Truck Space', 'column':'vacated', 'graph': false, 'grid_active': false, 'graph_active': false},
        //{'label': 'Net  Moveins', 'column':'moveins', 'graph': false, 'grid_active': false, 'graph_active': false},
        //{'label': 'Net Moveins Truck Space', 'column':'moveins_truck_space', 'graph': false, 'grid_active': false, 'graph_active': false},
        //{'label': 'New Customer Income', 'column':'new_customer', 'graph': false, 'grid_active': false, 'graph_active': false},
        //{'label': '$Ad Cost / $ Income', 'column':'cost_income', 'graph': false, 'grid_active': false, 'graph_active': false},
        {'label': 'Date (frequency)', 'column':'frequency', 'graph': false, 'grid_active': true, 'graph_active': false,}
    ],
    dataColumnsSnapshotListRepo:[
        {'label': 'Short Name', 'column':'facility_nick_name', 'graph': false, 'grid_active': true, 'graph_active': false},
        {'label': 'Name', 'column':'facility_name', 'graph': false, 'grid_active': true , 'graph_active': false},
        {'label': '$ Rented', 'column':'income_rented', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': 'Potential', 'column':'potential', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': '# Rented', 'column':'count_rented', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': 'Total Units', 'column':'total_units', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': 'Area Rented', 'column':'area_rented', 'graph': false, 'grid_active': true, 'graph_active': true},
        {'label': 'Total Area', 'column':'total_area', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': '$ %', 'column':'occupied_income_percent', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': '# %', 'column':'occupied_unit_count_percent', 'graph': true, 'grid_active': true, 'graph_active': true},
        {'label': 'Area %', 'column':'occupied_unit_area_percent', 'graph': true, 'grid_active': true, 'graph_active': true}
    ],
    reportFacilitySummaryListConfig: {
        labels: [],
        data: []
    },
    facilitySummaryChart:{
        labels: null,
        datasets: null
    },
    facilitySnapshotListChart:{
        labels: null,
        datasets: null
    },
    loading : false
}

var getters = {};
var mutations = {};
var actions = {};

for(let prop in state){
    //define getters
    getters[prop] = ( _state) =>{return _state[prop]}
    //define muttations
    mutations[`set_${prop}`] = (_state, newValue) => { _state[prop] = newValue }
    //define actions
    actions[`set_${prop}`] = (ctx, newValue) => {ctx.commit(`set_${prop}`, newValue)}
}

const facility_summary_report_store = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
}

export default facility_summary_report_store;